<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #112357;
}
h1, h2, h3, h4, h5, h6{
  color: #24A7DF;
}
.text-center{
    text-align: center;
}
.btn:focus,
input{
  box-shadow: none !important;
  outline: none !important;
}
th{
  color: #5965B1;
  font-weight: normal;
  font-size: 16px;
}
td{
  color: #112357;
  font-size: 20px;
  padding: 20px 10px 20px 0 !important;
}
.orders-container tr,
.orders-container th,
.table > :not(caption) > * > * {
  border-bottom: 1px solid #5965B1 !important;
}
.table > :not(:first-child) {
  border-top: none !important;
}
.custom-control-label{
  color: #5965B1 !important;
  font-size: 16px;
  margin-left: 5px;
}

.required-check .custom-control-label{
    color: #D85067 !important;
}

.radioBtn input[type="radio"]{
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
}
.radioBtn{
  /* border: 1px solid rgba(89, 101, 177, 1); */
  border-radius: 5px !important;
}

.radioBtn .btn-outline-primary,
.radioBtn .btn-outline-primary.disabled{
  color: rgba(89, 101, 177, 0.4);
  border: none !important;
  font-size: 20px;
  font-weight: normal;
}

.radioBtn .btn-outline-primary:hover,
.radioBtn .btn-outline-primary.disabled:hover{
  color: rgba(89, 101, 177, 0.4);
  background: transparent;
}

.radioBtn .btn-outline-primary:focus,
.radioBtn .btn-outline-primary.active{
  background: #24A7DF !important;
  color: #fff !important;
  border-radius: 5px !important;
  border: none;
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn{
  opacity: 1 !important;
}
.dropdown{
  color: #112357 !important;
  background: #F7F9FF !important;
}
.dropdown > li.active,
.dropdown > li:hover{
  background: #F0F2FF;
}

.search-input,
.search-input.required{
  border-color: #5965B1 !important;
}

.required-select .search-input,
.required-select .search-input.required{
  border-color: #D85067 !important;
}

fieldset .search-input,
fieldset .search-input.required{
  border-color: transparent !important;
}
.size-container .search-input,
fieldset .search-input{
    text-align: right !important;
    padding-right: 50px !important;
}
.size-container .search-input{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.size-container .single-select-wrapper{
  margin-bottom: 0 !important;
}
.form-floating > label {
    padding: 1rem 1.75rem !important;
    color: rgba(89, 101, 177, 1);
    opacity: 0.4;
    font-size: 20px;
}

.form-floating > .form-control,
.form-control .search-input{
  text-align: left !important;
}



.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label{
    opacity: 1 !important;
    font-size: 12px;
}

.hide-label .form-control ~ label{
  display: none;
}

.form-control{
    border-color: #5965B1 !important;
    color: #112357;
    font-size: 18px;
}

.form-control:disabled, .form-control[readonly] {
    background-color: transparent !important;
    opacity: 1;
}

.vue-numeric-input.updown{
  margin-left: auto;
  position: absolute;
  bottom: 30%;
  right: 1rem;
  width: 90px !important;
  border: none !important;
  background: transparent !important;
}
.vue-numeric-input.updown .numeric-input{
  background: #F7F9FF !important;
  text-align: center !important;
  padding: 5px 5px;
}
.vue-numeric-input.updown .btn-increment,
.vue-numeric-input.updown .btn-decrement{
    background: #fff !important;
    border: 1px solid #fff !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}
.vue-numeric-input.updown .btn-increment .btn-icon::before,
.vue-numeric-input.updown .btn-decrement .btn-icon::before{
    border-radius: 0 !important;
    background-image: none !important;
}
.vue-numeric-input.updown .btn-increment .btn-icon,
.vue-numeric-input .btn-increment .btn-icon{
  border-radius: 0 !important;
  background-image: url('./assets/imgs/icn_arrow_up_active.svg') !important;
  background-repeat: no-repeat;
  border: none !important;
  height: 10px !important;
  width: 15px !important;
}
.vue-numeric-input.updown .btn-decrement .btn-icon,
.vue-numeric-input .btn-decrement .btn-icon{
  background-image: url('./assets/imgs/icn_arrow_down_active.svg') !important;
  background-repeat: no-repeat;
  border: none !important;
  height: 10px !important;
  width: 15px !important;
}
.vue-numeric-input.updown .btn-increment, .vue-numeric-input.updown .btn-decrement{
  display: none;
}
.form-control-qty{
  border: none !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input[type="checkbox"] {
  height: 15px;
  width: 15px;
  vertical-align: middle;
  margin: 0 0.4em 0.4em 0;
  border: 1px solid #5965B1; 
  -webkit-appearance: none;
  -webkit-transition: box-shadow 200ms;
}
/* border radius for checkbox */
input[type="checkbox"] {
  -webkit-border-radius:2px;
  border-radius:2px;
}
/* hover state */
input[type="checkbox"]:not(:disabled):hover {
  border-color:#5965B1;   
}
/* active state */
input[type="checkbox"]:active:not(:disabled) {
  border-color:#5965B1;
}
/* focus state */
input[type="checkbox"]:focus {
  outline:none;
}
/* input checked border color */
input[type="checkbox"]:checked {
  border-color:#5965B1;
  background-color: #5965B1;
}
/* checkbox checked */
input[type="checkbox"]:checked:before {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: 4px;
  margin-top: 1px;
}

.single-select-wrapper .form-floating > label {
    padding-left: 1rem !important;
}


.form-control:focus {
    -webkit-box-shadow: 0px 0px 5px rgba(89, 101, 177, 0.7) !important;
    -moz-box-shadow: 0px 0px 5px rgba(89, 101, 177, 0.7) !important;
    box-shadow: 0px 0px 5px rgba(89, 101, 177, 0.7) !important;
}
fieldset .form-control:focus{
  box-shadow: none !important;
}
.required{
  border: 1px solid #D85067 !important;
}

.custom-file, .custom-file-input {
    position: relative;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}

.custom-file {
    display: inline-block;
    margin-bottom: 0;
}
.required.custom-file {
  border: none !important;
}
.required.custom-file .custom-file-label{
  border: 1px solid #D85067;
}
.custom-file-input {
    z-index: -5;
    margin: 0;
    overflow: hidden;
    opacity: 0;
}
.custom-file-label, .custom-file-label:after {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.3);
}

.active .custom-file-label, .active .custom-file-label:after {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 1);
}

.custom-file-label {
    left: 0;
    z-index: 1;
    height: calc(1.5em + 0.75rem + 2px);
    overflow: hidden;
    font-weight: 400;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.custom-file-label {
    white-space: nowrap;
    overflow-x: hidden;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}

.custom-file-input:focus + .custom-file-label{
    border: 1px solid #000;
}

.custom-control-label:before, .custom-file-label, .custom-select {
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.form-order fieldset .form-control,
.form-order fieldset .form-floating > .form-control{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

@media (max-width: 1600px) {
  .form-floating > label {
    font-size: 16px;
  }
  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label{
      font-size: 11px;
      transform: scale(0.85) translateY(-0.8rem) translateX(0.15rem);
      -webkit-transform: scale(0.85) translateY(-0.8rem) translateX(0.15rem);
  }
  .single-select-wrapper .form-floating > .form-control:not(:placeholder-shown) ~ label{
    padding-left: 1rem !important;
  }
  .form-floating > .form-control{
    padding: 1rem 0.75rem 0 1rem !important;
    font-size: 15px !important
  }
  .form-floating > .form-control, .form-floating > .form-select {
      height: calc(2.7rem + 2px) !important;
      line-height: 1 !important;
  }
  .form-floating > label {
    padding: 0.6rem 1.75rem !important;
  }
  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label{
    opacity: 1 !important;
    font-size: 12px;
    padding: 1rem 1.75rem !important;
  }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn{
    background: #F7F9FF;
  }
  .btn-group.active > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn{
    background: transparent;
  }
  
  .radioBtn .btn-outline-primary{
    font-size: 16px !important;
  }
  .size-container .search-input{
      padding-top: 0.5rem !important;
      padding-bottom: 0.5rem !important;
  }
  .vue-numeric-input.updown{
    bottom: 15%;
  }
  fieldset .search-input,
  fieldset .search-input.required{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  th{
    font-size: 12px;
  }
  td{
    font-size: 15px;
    padding: 20px 10px 20px 0 !important;
  }
  .custom-control-label{
    font-size: 13px;
  }

}
.spinner-border {
    display: inline-block;
    width: 1.5rem !important;
    height: 1.5rem !important;
}
.modal-header{
    border: none !important;
}
.modal-header button{
  background: transparent !important;
  border: none !important;
  font-size: 30px;
  /* padding: 0; */
  line-height: 1;
}

#modal-view-order .modal-body{
  padding-top: 0px !important;
  padding-bottom: 8% !important;
  margin: auto;
  width: 100%;
  max-width: 80%;
  text-align: center;
}
#modal-view-order .modal-header{
  border-bottom: solid 1px #cad1d7;
}

.smart-pagination{
    text-align: center !important;
}
.smart-pagination .pagination{
    display: -webkit-inline-flex !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
}
.page-link{
    color: #5965B1 !important;
    box-shadow: none !important;
    outline: none !important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #fff !important;
    background-color: #5965B1 !important;
    border-color: #5965B1 !important;
}

/* tabs */
.nav-tabs .nav-item{
    width: 50% !important;
    text-align: center;
    border: none !important;
}
.nav-tabs,
.nav-tabs .nav-link.active, 
.nav-tabs .nav-item.show .nav-link{
    border: none !important;
}
.nav-tabs .nav-link{
  color: #24A7DF !important;
  background: #fff !important;
  border: 1px solid #24A7DF !important;
  border-radius: 5px !important;
}
.nav-tabs .nav-link.active{
  color: #fff !important;
  background: #24A7DF !important;
  border-radius: 5px !important;
  z-index: 22;
}


@media (max-width: 768px) {
  .form-floating > label {
    font-size: 14px;
  }
  .radioBtn .btn-outline-primary{
    font-size: 14px !important;
  }
  td{
    font-size: 12px;
  }
  .table.b-table{
    margin-left: -11%;
  }
}

@media (max-width: 433px) {
  .form-floating > label {
    font-size: 14px;
  }
  .form-floating .search-input{
    height: calc(3.7rem + 2px) !important;
  }
}

#modal-size .table{
  border: 1px solid #000;
}
#modal-size .table td{
  padding: 5px !important;
  text-align: center;
}
#modal-size .table th{
  padding: 5px !important;
  text-align: center;
}

</style>
